import storeService from 'src/services/store';

export default function () {
  const store = storeService.getStore();
  const state = store && store.getState();
  const profile = state && state.profile;

  return profile && profile.get('userId');
}
